import { render } from "./RightSidebar.mobile.vue?vue&type=template&id=5c97f2e3"
import script from "./RightSidebar.mobile.vue?vue&type=script&lang=js"
export * from "./RightSidebar.mobile.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/layouts/_partials/RightSidebar.mobile.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5c97f2e3"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5c97f2e3', __exports__)) {
    api.reload('5c97f2e3', __exports__)
  }
  
  module.hot.accept("./RightSidebar.mobile.vue?vue&type=template&id=5c97f2e3", () => {
    api.rerender('5c97f2e3', render)
  })

}


export default __exports__